import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'tlc-sample-data-banner-info',
  template: `
    <span class="status-dot"></span>
    <span class="message"
      >{{ messagePrefix() }} <a class="cta" (click)="ctaClick.emit()">{{ ctaLabel() }}</a>
      {{ messageSuffix() }}</span
    >
  `,
  styleUrl: './sample-data-banner-info.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TellentSampleDataBannerInfoComponent {
  public messagePrefix = input.required<string>();
  public messageSuffix = input.required<string>();
  public ctaLabel = input.required<string>();

  public ctaClick = output<void>();
}
